import { formatCpf } from './mask';

/**
 * O documento do aluno, que nem sempre e CPF: a escola matricula estrangeiros,
 * e o cadastro deles so saia com um numero inventado nos 11 digitos.
 *
 * Espelha `src/utils/documento.ts` do windfall-api. As duas pontas precisam
 * concordar sobre o que e valido, senao o formulario aceita o que a API recusa,
 * e o admin leva um 400 sem saber que campo corrigir.
 */
export type TipoDocumento = 'CPF' | 'PASSAPORTE' | 'OUTRO';

/** Digitos de um CPF, ja sem a mascara. */
export const DIGITOS_CPF = 11;

/** Teto de um documento estrangeiro, igual ao do backend. */
export const MAX_DOCUMENTO = 30;

/**
 * A ordem e a do select. CPF primeiro por ser o caso comum da escola; OUTRO por
 * ultimo por ser a saida para o que nao cabe nos dois anteriores.
 */
export const TIPOS_DOCUMENTO: { valor: TipoDocumento; rotulo: string }[] = [
	{ valor: 'CPF', rotulo: 'CPF' },
	{ valor: 'PASSAPORTE', rotulo: 'Passaporte' },
	{ valor: 'OUTRO', rotulo: 'Outro documento' }
];

/**
 * Rotulo do campo do numero. Muda com o tipo para o formulario dizer o que esta
 * pedindo sem precisar de texto de ajuda embaixo.
 */
export const rotuloDocumento = (tipo: TipoDocumento) =>
	tipo === 'CPF' ? 'CPF' : tipo === 'PASSAPORTE' ? 'Passaporte' : 'Documento';

export const placeholderDocumento = (tipo: TipoDocumento) =>
	tipo === 'CPF' ? '000.000.000-00' : tipo === 'PASSAPORTE' ? 'FX123456' : 'Número do documento';

/**
 * Quantos caracteres o campo aceita. O CPF conta com a mascara (14); os outros
 * param no limite da coluna.
 */
export const maxDocumento = (tipo: TipoDocumento) => (tipo === 'CPF' ? 14 : MAX_DOCUMENTO);

/**
 * Formata o que foi digitado conforme o tipo. So o CPF tem mascara: passaporte
 * varia por pais emissor e OUTRO e justamente a saida para o que nao tem padrao,
 * entao mascarar os dois recusaria documento legitimo.
 *
 * Tambem e o que roda ao TROCAR de tipo, e por isso nao inventa caractere
 * nenhum: trocar para CPF mantem os digitos que ja estavam la, trocar para os
 * outros mantem o texto como esta. Limpar o campo na troca seria pior, porque
 * um clique errado no select apagaria o numero ja digitado.
 */
export const formatDocumento = (tipo: TipoDocumento, valor: string) =>
	tipo === 'CPF' ? formatCpf(valor) : valor.slice(0, MAX_DOCUMENTO);

/**
 * Mensagem do que esta errado, ou null se o par esta valido.
 *
 * E a excecao deliberada a regra de `validacao.ts`, que so tem predicados: aqui
 * a mensagem depende do tipo escolhido, e os dois drawers do aluno precisam
 * dizer exatamente a mesma coisa.
 */
export const erroDocumento = (tipo: TipoDocumento, valor: string): string | null => {
	if (!valor.trim()) return `${rotuloDocumento(tipo)} é obrigatório!`;

	if (tipo === 'CPF') {
		return valor.replace(/\D/g, '').length === DIGITOS_CPF ? null : `Informe os ${DIGITOS_CPF} dígitos do CPF.`;
	}

	return valor.trim().length <= MAX_DOCUMENTO
		? null
		: `O documento pode ter no máximo ${MAX_DOCUMENTO} caracteres.`;
};
